module.exports = __webpack_public_path__ + "img/blackBackground.393ca8f3.jpg";